/** Languages supported across Klareo apps. */
export const SUPPORTED_LANGUAGES = ['en', 'fr', 'ar'] as const;

/** Type for supported language codes. */
export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

/** Languages that use right-to-left text direction. */
export const RTL_LANGUAGES = ['ar', 'he', 'fa'] as const;
